<template>
  <div>
    <b-col>
      <b-container fluid>
        <form @submit.stop.prevent="postShipping" v-if="shipping.from">
          <b-form-row>
            <b-col>
              <label for="reference" v-translate>Company</label>
              <company-autocomplete v-if="!company" ref="companyAc" @selected="onSearchCompanySelected" :includes="['applications']" />
              <b-card v-if="company">
                <span class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="company = null; validApp = profile.company.applications.find(x => x.platform_id === null) || profile.company.applications.find(x => x.platform.name === 'Moova')">×</span>
                <company-card :company="company" profilePictureSize="110px" />
              </b-card>
            </b-col>
          </b-form-row>
          <b-form-row v-if="company">
            <b-card id="shipping-from">
              <h4>
                <img src="@/assets/img/ic_origen.svg" alt="">
                <translate>Origin</translate>
              </h4>
              <create-checkpoint-address-form-b2b :shipping="shipping" checkpoint="from" @place-selected="emitPlaceSelected($event, 'from')" />
              <b-form-row>
                <div class="form-group col-sm-12">
                  <label for="origin-contact-name" v-translate>Contact Name</label>
                  <div class="input-group">
                    <b-form-input id="origin-contact-name" v-model="shipping.from.contact.firstName" required />
                  </div>
                </div>
                <div class="form-group col-sm-12">
                  <label for="origin-contact-instructions" v-translate>Instructions on Origin</label>
                  <div class="input-group">
                    <b-form-textarea id="origin-contact-instructions" v-model="shipping.from.instructions" />
                  </div>
                </div>
              </b-form-row>
              <b-form-row>
                <b-form-group class="col-12">
                  <b-form-checkbox v-model="fullFormFrom"><translate>Show Extra Fields</translate></b-form-checkbox>
                </b-form-group>
              </b-form-row>
              <b-collapse :visible="!!fullFormFrom">
                <b-form-row>
                  <div class="form-group col-sm-6">
                    <label for="origin-contact-email" v-translate>Contact Email</label>
                    <div class="input-group">
                      <b-form-input id="origin-contact-email" type="email" v-model="shipping.from.contact.email" />
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="origin-contact-phone" v-translate>Contact Phone</label>
                    <div class="input-group">
                      <cleave :options="{ phone: true, phoneRegionCode: this.company.country_iso_code }" class="form-control" v-model="shipping.from.contact.phone"></cleave>
                    </div>
                  </div>
                </b-form-row>
              </b-collapse>
            </b-card>

            <b-card id="shipping-to">
              <h4><img src="@/assets/img/ic_destino.svg" alt=""> <translate>Destination</translate></h4>
              <create-checkpoint-address-form-b2b :shipping="shipping" checkpoint="to" @place-selected="emitPlaceSelected($event, 'to')" />
              <b-form-row>
                <div class="form-group col-sm-12">
                  <label for="destination-contact-name" v-translate>Contact Name</label>
                  <div class="input-group">
                    <b-form-input id="destination-contact-name" v-model="shipping.to.contact.firstName" required />
                  </div>
                </div>
                <div class="form-group col-sm-12">
                  <label for="to-instructions" v-translate>Instructions on Destination</label>
                  <div class="input-group">
                    <b-form-textarea id="to-instructions" v-model="shipping.to.instructions" />
                  </div>
                </div>
                <div class="form-group col-sm-6">
                  <label for="external-code" v-translate>External Code</label>
                  <div class="input-group">
                    <b-form-input id="external-code" type="text" v-model="shipping.internalCode" />
                  </div>
                </div>
              </b-form-row>
              <b-form-row>
                <b-form-group class="col-12">
                  <b-form-checkbox v-model="fullFormTo"><translate>Show Extra Fields</translate></b-form-checkbox>
                </b-form-group>
              </b-form-row>
              <b-collapse :visible="!!fullFormTo">
                <b-form-row>
                  <div class="form-group col-sm-6">
                    <label for="destination-contact-email" v-translate>Contact Email</label>
                    <div class="input-group">
                      <b-form-input id="destination-contact-email" type="email" v-model="shipping.to.contact.email" />
                    </div>
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="destination-contact-phone" v-translate>Contact Phone</label>
                    <div class="input-group">
                      <cleave id="destination-contact-phone" :options="{ phone: true, phoneRegionCode: this.company.country_iso_code }" class="form-control" v-model="shipping.to.contact.phone"></cleave>
                    </div>
                  </div>
                  <div class="form-group col-sm-12">
                    <label for="description" v-translate>Description</label>
                    <div class="input-group">
                      <b-form-textarea id="description" v-model="shipping.description" />
                    </div>
                  </div>
                </b-form-row>
              </b-collapse>
            </b-card>
          </b-form-row>

          <b-form-row v-if="ecosystemModules.items.self && !newShipping.items">
            <b-card>
              <h4>{{ecosystemModules.items.label || $gettext('Items')}}</h4>
              <div class="input-group" v-if="!shipping.items || shipping.items.length === 0">
                <item-autocomplete @selected="onSearchItemSelected" />
              </div>
              <p v-else>
                <strong>{{ shipping.items[0].reference_code }}</strong> {{ shipping.items[0].description ? `(${shipping.items[0].description})` : ''}}
                <b-badge variant="danger" href="#" @click.prevent="shipping.items = []; emitPlaceSelected(null, 'item');">×</b-badge>
              </p>
            </b-card>
          </b-form-row>

          <b-form-row v-if="ecosystemModules.items.self && !newShipping.items">
            <b-card>
              <h4 v-translate>Shipment Quantity</h4>
              <div class="input-group">
                <b-form-select v-model="multipleShipments" :options="Array.from({length: 15}, (_, i) => i + 1)" :disabled="shipping.items && shipping.items.length > 0"></b-form-select>
              </div>
            </b-card>
          </b-form-row>

          <b-form-row v-if="company">
            <b-form-group class="col-12 form-actions">
              <b-button type="submit" variant="secondary" size="md" :disabled="(!shipping.from.placeId && !shipping.from.coords) || !shipping.to.placeId || working">
                <b-spinner small v-if="working"></b-spinner>
                <translate>Post Shipping</translate>
              </b-button>
            </b-form-group>
          </b-form-row>
        </form>
      </b-container>
    </b-col>
    <b-modal id='createShippingSuccessMessage' ref='createShippingSuccessMessage' size="md" hide-footer @hide="emitSuccess()">
      <div slot="modal-title" v-translate>Shipments Created</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <h3 class="my-5 text-center" v-translate="{qty: shippingsCreated.length}" :translate-n="shippingsCreated.length" translate-plural="%{qty} shipments were created!">%{qty} shipment was created!</h3>
      <div class="text-center" v-if="shippingsCreated.length < 40">
        <b-button variant="success" :to="{name: 'ShippingsList', query: {qf: JSON.stringify({'shipping-id': shippingsCreated.map(x => x.id).join('\n')})}}" target="_blank" @click="emitSuccess()" v-translate>
          Open the Created Shipments in the Shipment List
        </b-button>
      </div>
      <div class="text-center" v-else>
        <b-button variant="success" :to="{name: 'ShippingsList'}" target="_blank" @click="emitSuccess()" v-translate>
          Open the Shipment List
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CompanyAutocomplete from '@/components/Autocompletes/CompanyAutocomplete'
import ItemAutocomplete from '@/components/Autocompletes/ItemAutocomplete'
import CreateCheckpointAddressFormB2b from '@/components/Shippings/CreateCheckpointAddressFormB2b'
import Cleave from 'vue-cleave'
export default {
  name: 'CompanyNewShipping',
  components: {
    CompanyAutocomplete,
    ItemAutocomplete,
    CreateCheckpointAddressFormB2b,
    Cleave
  },
  props: {
    newShipping: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      searchCompanyQuery: '',
      companyAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control'
      },
      minCharacter: 2,
      company: this.$store.getters.profile.company,
      apiCredentials: {},
      validApp: this.$store.getters.profile.company.applications.find(x => x.platform_id === null) || this.$store.getters.profile.company.applications.find(x => x.platform.name === 'Moova'),
      shipping: {},
      setAsReady: false,
      fullFormFrom: this.$cookies.get('fullFormFrom') || false,
      fullFormTo: this.$cookies.get('fullFormTo') || false,
      multipleShipments: 1,
      shippingsCreated: [],
      working: false
    }
  },
  watch: {
    fullFormFrom(val) {
      if (val) {
        this.$cookies.set('fullFormFrom', 'true')
      } else {
        this.$cookies.remove('fullFormFrom')
      }
    },
    fullFormTo(val) {
      if (val) {
        this.$cookies.set('fullFormTo', 'true')
      } else {
        this.$cookies.remove('fullFormTo')
      }
    },
    'shipping.items': {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.multipleShipments = 1
        }
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.validApp) {
        if (this.isGcmAdmin) {
          this.createDefaultApplication(this.profile.company)
        }
      }
      this.shipping = {
        ...this.newShipping,
        ...{
          conf: {
            ...this.newShipping.conf,
            ...{
              geofences: {
                from: {},
                to: {}
              },
              extraCheckpoints: {
                beforePickup: [],
                beforeDelivery: []
              }
            }
          }
        },
        ...{
          items: [
            ...this.newShipping.items || []
          ]
        }
      }
      this.shipping.sizeId = this.shippingSizes[0].id
      this.onSearchCompanySelected(this.profile.company)
    },
    async postShipping() {
      if (this.apiCredentials && this.apiCredentials.active === 1) {
        this.working = true
        if (this.shipping.conf.extraCheckpoints) {
          for (const event in this.shipping.conf.extraCheckpoints) {
            if (this.shipping.conf.extraCheckpoints[event].length === 0) {
              delete this.shipping.conf.extraCheckpoints[event]
            }
          }
        }
        if (this.shipping.conf.geofences) {
          for (const checkpoint in this.shipping.conf.geofences) {
            if (!this.shipping.conf.geofences[checkpoint].id) {
              delete this.shipping.conf.geofences[checkpoint]
            }
          }
        }
        if (this.ecosystemConfig && this.ecosystemConfig.forcedShippingSettings && this.ecosystemConfig.forcedShippingSettings.length > 0) {
          let settings = this.ecosystemConfig.forcedShippingSettings.map(x => {
            return this.shippingSettings.find(y => y.text === x).value
          })
          this.shipping.settings = [...new Set((this.shipping.settings || []).concat(settings))]
        }

        this.multipleShipments = this.multipleShipments || 1

        for (let i = 0; i < this.multipleShipments; i++) {
          await this.$http.post(this.$appConfig.api.baseUrl + 'b2b/shippings?appId=' + this.apiCredentials.id, this.shipping, {before: this.changeAuth})
            .then(response => {
              this.shippingsCreated.push(response.body)
            })
        }
        if (this.multipleShipments > 1) {
          this.$refs.createShippingSuccessMessage.show()
        } else {
          this.openShipping(this.shippingsCreated[0].id)
          this.emitSuccess()
        }
        this.working = false
      } else {
        alert(this.$gettext('The company has no active Applications to post via B2B'))
      }
    },
    emitSuccess() {
      this.$emit('success', true)
    },
    changeAuth(req) {
      return req.headers.set('Authorization', this.apiCredentials.key)
    },
    onSearchCompanySelected(item) {
      this.apiCredentials = item.applications.find(x => x.platform_id === null) || item.applications.find(x => x.platform && x.platform.name === 'Moova')
      if (!this.apiCredentials || this.apiCredentials.active !== 1) {
        this.createDefaultApplication(item)
        return
      } else {
        this.company = item
        this.shipping.currency = window.countries.find(x => x.iso_code === item.country_iso_code).front_config.i18n.currency
        this.shipping.from.country = this.shipping.to.country = item.country_iso_code
        this.searchCompanyQuery = ''
      }
    },
    openShipping(id) {
      window.open('/shippings/edit/' + id, id)
    },
    createDefaultApplication(company) {
      let params = {
        name: company.name,
        company_id: company.id,
        active: true
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'applications', params)
        .then(response => {
          this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + company.id + '?includes[]=applications')
            .then(response => {
              this.onSearchCompanySelected(response.body)
            })
        })
    },
    onSearchItemSelected(item) {
      this.shipping.items = [item]
      if (item.item_tracking) {
        this.emitPlaceSelected([item.item_tracking.lat, item.item_tracking.lng], 'item')
      }
    },
    emitPlaceSelected(e, checkpoint) {
      this.$emit('place-selected', e, checkpoint)
    }
  }
}
</script>
